import type ISchoolPeriodUserRepository from '@/core/domain/school/user/ISchoolPeriodUserRepository'
import type { SchoolPeriodUserInput } from '@/core/domain/school/user/SchoolPeriodUser'

export class UpdateSchoolPeriodUserUseCase {
  private readonly schoolPeriodUserRepository: ISchoolPeriodUserRepository

  constructor(schoolPeriodUserRepository: ISchoolPeriodUserRepository) {
    this.schoolPeriodUserRepository = schoolPeriodUserRepository
  }

  async execute(schoolId: number, schoolPeriodId: number, userInput: SchoolPeriodUserInput) {
    return await this.schoolPeriodUserRepository.updateSchoolPeriodUser(
      schoolId,
      schoolPeriodId,
      userInput
    )
  }
}
